'use strict';

var getViewportWidth = require('../get-viewport-width');

/**
 * When the media query breakpoint is triggered from matchMedia this handler is fired.
 *
 * @param {MediaQueryListEvent} mqListEvent - Event fired when the media query breakpoint is triggered.
 */
var mediaQueryChange = function mediaQueryChange(mqListEvent) {
  var viewportWidth = getViewportWidth();
  // if the matches property of the media query object is true it is a mobile device
  window.dataLayer.push({
    event: 'optimize.activate',
    siteVersion: mqListEvent.matches ? 'mobile' : 'desktop',
    viewportWidth: viewportWidth
  });
};

module.exports = mediaQueryChange;